import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/auth/auth.service';
import { DeployPurchase, InfoPurchase } from 'src/app/core/interfaces/purchase.model';
import { Account } from 'src/app/core/interfaces/user.model';
import { AccountService } from 'src/app/core/services/account.service';
import { ParametersService } from 'src/app/core/services/parameters.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-subs-info',
  templateUrl: './subs-info.component.html',
  styleUrls: ['./subs-info.component.scss']
})
export class SubsInfoComponent implements OnInit {

  loading = false;

  modalPayment: any;
  modalLogin: any;
  modalRegister: any;
  modalConditions: any;

  userLogged: boolean = false;
  isMember: boolean = false;

  account: Account;
  readyToSub: boolean = false;

  selectedSubtype: number = 0;
  objetoPurchase: DeployPurchase = {
    type: 'suscription',
    subscriptionPlanId: 0,
  };
  infoCompra: InfoPurchase;
  condiciones = false;

  plansAll = [
    {
      id: 9,
      idAnual: 11,
      name: 'Suscripción Regular',
      nameAnual: 'Suscripción Regular Anual',
      description: '',
      price: 0,
      anualprice: 0,
      subtitle: 'Siendo parte de +Cinemateca podés disfrutar de:',
      texto1: 'Un catálogo de más de 400 películas',
      texto2: 'Contenidos exclusivos producidos por Cinemateca',
      texto3: 'Muestras de festivales uruguayos',
      texto4: 'Materiales de nuestro archivo fílmico digitalizados',
      footer: 'Y lo más importante... apoyás a Cinemateca.',
      isForMember: false,
    },
    {
      id: 10,
      idAnual: 12,
      name: 'Suscripción Regular para Socios',
      nameAnual: 'Suscripción Regular para Socios Anual',
      description: '',
      price: 0,
      anualprice: 0,
      subtitle: 'Siendo parte de +Cinemateca podés disfrutar de:',
      texto1: 'Un catálogo de más de 400 películas',
      texto2: 'Contenidos exclusivos producidos por Cinemateca',
      texto3: 'Muestras de festivales uruguayos',
      texto4: 'Materiales de nuestro archivo fílmico digitalizados',
      footer: 'Y lo más importante... apoyás a Cinemateca.',
      isForMember: true,
    },
    {
      id: 13,
      idAnual: 14,
      name: 'Suscripción Felix Oliver',
      nameAnual: 'Suscripción Felix Oliver Anual',
      description: '',
      price: 0,
      anualprice: 0,
      subtitle: 'Siendo parte de +Cinemateca podés disfrutar de:',
      texto1: 'Un catálogo de más de 400 películas',
      texto2: 'Contenidos exclusivos producidos por Cinemateca',
      texto3: 'Muestras de festivales uruguayos',
      texto4: 'Materiales de nuestro archivo fílmico digitalizados',
      footer: 'Y lo más importante... apoyás a Cinemateca.',
      isForMember: false,
    },
    {
      id: 18,
      idAnual: 19,
      name: 'Suscripción Felix Oliver Para Socios',
      nameAnual: 'Suscripción Felix Oliver Para Socios Anual',
      description: '',
      price: 0,
      anualprice: 0,
      subtitle: 'Siendo parte de +Cinemateca podés disfrutar de:',
      texto1: 'Un catálogo de más de 400 películas',
      texto2: 'Contenidos exclusivos producidos por Cinemateca',
      texto3: 'Muestras de festivales uruguayos',
      texto4: 'Materiales de nuestro archivo fílmico digitalizados',
      footer: 'Y lo más importante... apoyás a Cinemateca.',
      isForMember: true,
    },
  ];
  plans = [];

  constructor(private auth: AuthService, private AccountService: AccountService, private ParameterService: ParametersService) { }

  async ngOnInit() {
    this.loading = true;
    await this.cargarPrice();
    await this.loadAcount();
    this.loading = false;
  }

  async ngAfterViewInit() {
    this.modalLogin = $('#modalLogin');
    this.modalRegister = $('#modalRegister');
    this.modalPayment = $('#modalPayment');
    this.modalConditions = $('#modalConditions');
  }

  //#region Inits Loads

  async loadAcount() {
    this.userLogged = this.auth.getUserLogged();
    if (this.userLogged) {
      await this.AccountService.getAccountNoEvent().then(
        async (resp: Account) => {
          if (resp) {
            console.log("they not like us");

            this.account = resp;
            this.plans = this.plansAll.filter((p) => p.isForMember == this.account.isCinematecaMember);
          }
        },
      );
    }
  }

  checkLogin() {
    if (!this.auth.getUserLogged()) {
      this.abrirModal(this.modalLogin);
    }
    else {
      this.readyToSub = ((!this.account.suscription) || (this.account.suscription.status != 1));
      if (this.readyToSub) {
        switch (this.selectedSubtype) {
          case 1:
            this.sub_foMensual()
            break;
          case 2:
            this.sub_foAnual();
            break;
          case 3:
            this.sub_mensual();
            break;
          case 4:
            this.sub_anual();
            break;

          default:
            break;
        }
      }
      else {
        Swal.fire({
          icon: 'info',
          title: 'Ya está suscripto',
          text: 'Usted ya se encuentra suscripto en +CINEMATECA.',
          customClass: { popup: 'subinfo_suscrito' },
        });
      }
    }
  }

  prepareSubValues() {
    this.readyToSub = ((!this.account.suscription) || (this.account.suscription.status != 1));
  }

  //#endregion

  //#region Suscripciones

  async sub_foMensual() {
    const plan = this.plans[1];

    this.infoCompra = {
      type: 'subscription',
      title: plan.name,
      price: plan.price,
    };
    this.objetoPurchase.subscriptionPlanId = plan.id;

    if (this.condiciones) this.abrirModal(this.modalPayment);
    else this.abrirModal(this.modalConditions);
  }

  async sub_foAnual() {
    const plan = this.plans[1];

    this.infoCompra = {
      type: 'subscription',
      title: plan.nameAnual,
      price: plan.anualprice,
    };

    this.objetoPurchase.subscriptionPlanId = plan.idAnual;

    if (this.condiciones) this.abrirModal(this.modalPayment);
    else this.abrirModal(this.modalConditions);
  }

  async sub_mensual() {
    const plan = this.plans[0];

    this.infoCompra = {
      type: 'subscription',
      title: plan.name,
      price: plan.price,
    };
    this.objetoPurchase.subscriptionPlanId = plan.id;

    if (this.condiciones) this.abrirModal(this.modalPayment);
    else this.abrirModal(this.modalConditions);
  }

  async sub_anual() {
    const plan = this.plans[0];

    this.infoCompra = {
      type: 'subscription',
      title: plan.nameAnual,
      price: plan.anualprice,
    };

    this.objetoPurchase.subscriptionPlanId = plan.idAnual;

    if (this.condiciones) this.abrirModal(this.modalPayment);
    else this.abrirModal(this.modalConditions);
  }

  async cargarPrice() {
    await this.ParameterService.getAllSubPrices().then((res) => {
      if (res) {
        this.plansAll[0].price = parseInt(res[0].value)       //Regular Mensual
        this.plansAll[0].anualprice = parseInt(res[2].value)  //Regular Anual
        this.plansAll[1].price = parseInt(res[1].value)       //Regular Mensual Socios
        this.plansAll[1].anualprice = parseInt(res[3].value)  //Regular Anual Socios
        this.plansAll[2].price = parseInt(res[4].value)       //Felix Oliver Mensual
        this.plansAll[2].anualprice = parseInt(res[6].value)  //Felix Oliver Anual
        this.plansAll[3].price = parseInt(res[5].value)       //Felix Oliver Mensual Socios
        this.plansAll[3].anualprice = parseInt(res[7].value)  //Felix Oliver Anual Socios

        this.plans = this.plansAll.filter((p) => p.isForMember == false);
      }
    })

  }

  clickSub(ev: Event, type: number) {
    ev.preventDefault();
    this.selectedSubtype = type;
    this.checkLogin();
  }

  //#endregion

  //#region Modals

  abrirModal(modal: any) {
    this.modalPayment.modal('hide');
    this.modalLogin.modal('hide');
    this.modalRegister.modal('hide');
    this.modalConditions.modal('hide');

    if (modal) {
      if (typeof modal === 'string') this[modal].modal('show');
      if (typeof modal === 'object') modal.modal('show');
    }
  }

  onLogin(respuesta) {
    //doesnt reach here??
    console.log(respuesta);

    if (respuesta) {
      this.modalLogin.modal('hide');
      this.loadAcount();
    }
  }

  onRegister(respuesta) {
    if (respuesta) this.modalRegister.modal('hide');
  }

  onCondiciones(estado) {
    this.condiciones = estado;
    if (estado) this.abrirModal(this.modalPayment);
  }

  //#endregion

  ngOnDestroy(): void {
    this.modalPayment.modal('hide');
    this.modalLogin.modal('hide');
    this.modalRegister.modal('hide');
    this.modalConditions.modal('hide');
  }

}
